import React from 'react';
import axios from 'axios';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Bold } from 'lucide-react';
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import ApplicationForm from '../components/ApplicationForm';
import "../css/Career.css";

export default function About() {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [setlang, setLang] = useState("fa");
  const { lang } = useParams();
  const [newApplication, setNewApplication] = useState([]);
  const [error, setError] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [success, setSuccess] = useState(false);
  const [status, setStatus] = useState(null);
  const [resumeFile, setResumeFile] = useState(null);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    major: '',
    contact_phone: '',
    contact_email: '',
  });

  useEffect(() => {
    fetch("/data/Careers.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .then(setLoading(false))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleResumeChange = (e) => {
    if (e.target.files.length > 0) {
      setResumeFile(e.target.files[0]); 
    }
  };
  const handleSendApplication = (newApplica) => {
    setNewApplication([...newApplication, newApplica]);
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  
  
  if (loading) return <Loading />;  
  if (!content) return <p>{setlang==="en"?"Loading...":"در حال بارگذاری..."}</p>;

  return (
    <>
      <NavbarLog />
      <div className="career-page">
        <div className="career-grid">
          <h1>{content.h1}</h1>
          <p>{content.p1}</p>

          {content.positions.map((job, idx) => (
            <div className="career-section" key={idx}>
              <h2>{job.T}</h2>
              <p>{job.D}</p>
              
              {job.T !== "" ? (
                <>
                  <div>
                    <h3>در این موقعیت تو:</h3>
                  {job.Q.map((qual, idx) => (
                    <ul key={idx}>
                      <li>{qual}</li>
                    </ul> 
                    ))}
                  </div>
                  <div>
                    <h3>مهارت‌هایی که با خود به همراه می‌آوری:</h3>
                  {job.E.map((exp, idx) => (
                    <ul key={idx}>
                      <li>{exp}</li>
                    </ul> 
                  ))}
                  </div>
                </>
                ):(
                  <p>{job.zero}</p>
                )}
            </div>
          ))}
        </div>

        <div>
          <div className=''>
            <ApplicationForm 
              oncreated = {handleSendApplication}
              onCancel = {() => {
                setResumeFile(null);
              }}
              content = {content}
              setlang = {setlang}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}